
import React, { useCallback, memo, useState } from 'react';
import PropTypes from 'prop-types';


import { StyledTabItem, StyledTabItemLabel } from './Tabs.styled';

const TabItem = ({ id, label, Icon, isSelected = false, onClick }) => {
  
  const handleClick = useCallback(
    (event) => {
      event?.stopPropagation?.();
      if (typeof onClick === 'function') {
        onClick(id);
      }
    },
    [id, onClick],
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleClick(event);
      }
    },
    [handleClick],
  );

  return (
    <StyledTabItem
      className="respark_tab"
      role="tab"
      tabIndex={0}
      aria-label={label}
      aria-selected={isSelected}
      title={label}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <Icon />
      {label && (
        <StyledTabItemLabel className="respark_tab-label">
          {label}
        </StyledTabItemLabel>
      )}
    </StyledTabItem>
  );
};


TabItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.instanceOf(Object),
  ]).isRequired,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
};

export default memo(TabItem);
